const storesLoader = document.querySelector('.page-loader');
const parentTargetNode = document.documentElement;
const config = { childList: true, subtree: true };

function mailAction() {
    let mailButtons = document.querySelectorAll('.store-tools form');
    mailButtons.forEach((element) => {
        element.addEventListener('submit', (event) => {
            event.preventDefault();
            event.stopPropagation();
            storesLoader.classList.add('loading');
            element.submit();
        });
    });
}


// Change when dom is inserted.
// Fonction de rappel pour quand les mutations sont observées
const callbackaction = (mutationsList) => {
    for(let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
                const target = node;
                if (target.id === "stores") {
                    mailAction();
                }
            });
        }
    }
};
const observeraction = new MutationObserver(callbackaction);
observeraction.observe(parentTargetNode, config);
